module.exports = __webpack_public_path__ + "c76ddeba3f3e48c52c2720d865ecb4fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/lyzarsky-vycvik-6.jpg
// module id = 1195
// module chunks = 0